export default "__VITE_ASSET__BX08Rk4L__"